import axios from 'axios';

export const updateHTMLIEP = (domain, id, body) => axios.put(`${domain}/api/TemplateIEP/update-template/${id}`, body)
export const getHTMLIEP = (domain, id) => axios.get(`${domain}/api/TemplateIEP/get-template/${id}`)
export const getTemplateIEPByType = (domain, templateId, typeId) => axios.get(`${domain}/api/TemplateIEP/get-template-by-type/${templateId}/${typeId}`)

export const getLearningPlanById = (domain, id) => axios.get(`${domain}/api/LearningPlanIEP/learningPlan/${id}`);


export const uploadImageIEP = (domain, body) => axios.post(`${domain}/api/LearningPlanIEP/upload-file`, body);